import { IBiller, LiabilitySource } from '../../../billers/models/model';
import { CustomerBillerStoreService } from '../../../billers/services/customer-biller-store.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, map, startWith, switchMap, tap } from 'rxjs/operators';
import { BillerSearchService } from 'src/app/billers/services/biller-search.service';
import { BillerService } from 'src/app/billers/services/biller.service';
import { AddBillerForm } from '../../forms/add-biller.form';
import { Observable } from 'rxjs';

@Component({
standalone: false,
  selector: 'app-add-biller-dialog',
  styleUrls: ['./add-biller-dialog.component.scss'],
  templateUrl: './add-biller-dialog.component.html',
})
export class AddBillerDialogComponent implements OnInit {
  public form: AddBillerForm;
  public filteredOptions$: Observable<IBiller[]>;

  private billers: IBiller[] = [];

  constructor(
    private billerSearch: BillerSearchService,
    private customerBillerStoreService: CustomerBillerStoreService,
    private billerService: BillerService,
    private dialogRef: MatDialogRef<AddBillerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {}

  ngOnInit(): void {
    this.form = new AddBillerForm();
    this.billerSearch
      .init()
      .pipe(tap(() => (this.billers = this.filterBillers(this.data))))
      .subscribe();

    this.filteredOptions$ = this.form.biller.valueChanges.pipe(
      startWith(''),
      debounceTime(500),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this.filterBillers(name) : this.billers.slice())),
    );
  }

  public submit = () => {
    if (this.form.invalid) {
      return;
    }

    const biller = this.form.biller.value;
    if (this.data) {
      this.dialogRef.close({
        billerId: biller?.code ? biller.code : null,
        displayName: biller.name,
      });
      return;
    }

    if (biller?.code) {
      this.addCustomerBiller(biller);
    } else {
      const billerValue = typeof biller === 'string' ? biller : biller.name.trim();
      this.addBiller(billerValue);
    }
  };

  public displayFn(biller: IBiller): string {
    return biller.name;
  }

  private addBiller(biller: string): void {
    this.billerService
      .addBiller(biller)
      .pipe(
        tap((result: string) => {
          const newBiller: IBiller = { initial: result.substring(0, 1), code: result, name: result };
          this.addCustomerBiller(newBiller);
        }),
      )
      .subscribe();
  }

  private addCustomerBiller(biller: IBiller): void {
    let createdCustomerBillerId: string;
    this.customerBillerStoreService
      .addCustomerBiller(biller.code, LiabilitySource.MANUAL)
      .pipe(
        tap((customerBillerId: string) => (createdCustomerBillerId = customerBillerId)),
        switchMap((customerBillerId: string) =>
          this.customerBillerStoreService.updateLiabilitySource(customerBillerId, LiabilitySource.MANUAL),
        ),
        tap(() =>
          this.dialogRef.close({
            customerBillerId: createdCustomerBillerId,
            billerId: biller.code,
            displayName: biller.name,
          }),
        ),
      )
      .subscribe();
  }

  private filterBillers(billerName: string): IBiller[] {
    return this.billerSearch.search(billerName).all;
  }
}
